import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import { GET_POSTS } from "../../hooks/usePost";

const Search = () => {
  const [search, setSearch] = useState("");

  const { loading, error, data } = useQuery(GET_POSTS);
  let blogs = data?.blog_posts;

  let sortedPost;

  // if (typeof(blogs) = 'undefinded') {
  //   // alert("Not Found")
  // } else {
  //   sortedPost = blogs.filter((post) =>
  //     post?.title.toLowerCase().includes(search)
  //   );
  // }
 
//   if (typeof blogs == undefined) {
//    return alert("not found")
   
//   }
//   else if (blogs.length <= 0) {
//     alert("Not Found")
//   }
//   else
//   {
//     sortedPost = blogs.filter((post) =>
//       post?.title.toLowerCase().includes(search)
//     );
//     }
// console.log(sortedPost)
  return (
    <div className="my-10 text-3xl   ">
      <input type="text" onChange={(e) => setSearch(e.target.value)} />
      <button> Search</button>
      {/* {data?.blog_posts.map((blogPost) => (
        sortedPost=
      ))} */}
    </div>
  );
};

export default Search;
